import { useAuthSession } from '../lib/session'
import ClientSurveyFormPage from './clientTabs/ClientSurveyFormPage'

export default function SurveyForms() {
  const session = useAuthSession()
  return <ClientSurveyFormPage clientIdOverride={session?.currentClientId} />
}
